import type { FaireProductEntity } from "../../entity_types/product";

export const p_65acvv7p: FaireProductEntity = {
  token: "p_65acvv7p",
  type: "product",
  name: "Pink Balloons Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1a1ea6aee0db5d91231ce0be6ce96fb060beec273b0f5ece9e87bc58a1d84f30.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/31958ba2716e7ec987cfef7eb9f4ec9da67f4d7d0de341bb06dd0ee1a3df74da/1528334405.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:59.328Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
